module.exports = __webpack_public_path__ + "img/electric_enabled_selected.76131bdc.svg";